import { createContext } from 'react';

import type { NTabsNotificationProvider } from '@app/providers/TabsNotificationProvider/TabsNotificationProvider.types';

export const TabsContext = createContext<NTabsNotificationProvider.Context>({
  originalData: {},
  newData: [],
  setNewData: () => {},
  setOriginalData: () => {},
  tabInfo: '',
  setTabInfo: () => {},
});
